<template>
  <div class="change-personal-data-wrapper">
    <div class="change-personal-data-container">
      <div class="route-name">{{ $t(`message.sideMenu.${this.$route.name}`) }}</div>
      <div class="back-block" @click="$router.push({ name: 'settings' })">
        <img
          src="../../../../public/custom/images/back-arrow.svg"
          class="back-img"
          alt="Back arrow"
        />
        <span class="back-btn-text">{{ $t('message.loanPage.back') }}</span>
      </div>
      <div class="info-section">
        <div class="section-title">{{ $t('message.changePersonalDataAgreementPage.title') }}</div>
        <div class="section-description">{{ personalDataConsentText }}</div>
        <div class="personal-data-btn-container">
          <base-button
            :text="personalDataConsentBtnText"
            :min-height="'40px'"
            :is-loading="isPersonalDataBtnLoading"
            :disabled="isPersonalDataBtnLoading"
            @click="handlePersonalDataConsent()"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseButton from '../../../components/base/BaseButton.vue';

export default {
  name: 'ChangePersonalDataAgreement',
  inject: ['$httpService'],
  components: {
    BaseButton
  },
  data() {
    return {
      isPersonalDataBtnLoading: false
    };
  },
  async created() {
    await this.$store.dispatch('getProfile');
  },
  methods: {
    async handlePersonalDataConsent() {
      if (!this.agreePersonalDataProcessing) {
        this.$router.push({ name: 'sign-personal-data-agreement' });
        return;
      }

      await this.revokePersonalDataAgreement();
    },
    async revokePersonalDataAgreement() {
      this.isPersonalDataBtnLoading = true;

      try {
        const response = await this.$httpService.agreement.revokePersonalDataAgreement();

        if (!response) {
          throw new Error('Personal data revoke failed');
        }

        await this.$store.dispatch('getProfile');
        this.$toast.success(this.$t('message.changePersonalDataAgreementPage.revokeSuccess'));
      } catch (error) {
        this.$toast.error(this.$t('message.changePersonalDataAgreementPage.revokeError'));
      } finally {
        this.isPersonalDataBtnLoading = false;
      }
    }
  },
  computed: {
    ...mapGetters(['profile']),
    agreePersonalDataProcessing() {
      return !!this.profile?.agreePersonalDataProcessing;
    },
    personalDataConsentText() {
      return this.agreePersonalDataProcessing
        ? this.$t('message.changePersonalDataAgreementPage.consentGiven')
        : this.$t('message.changePersonalDataAgreementPage.consentNotGiven');
    },
    personalDataConsentBtnText() {
      return this.agreePersonalDataProcessing
        ? this.$t('message.changePersonalDataAgreementPage.buttons.revokeConsent')
        : this.$t('message.changePersonalDataAgreementPage.buttons.giveConsent');
    }
  }
};
</script>

<style lang="scss" scoped>
  .change-personal-data-wrapper {
    @include page-wrapper-with-header-and-footer;

    padding-top: 20px;
    box-sizing: border-box;
  }

  .change-personal-data-container {
    width: 95%;
    min-height: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
  }

  .info-section {
    width: 100%;
    padding: 20px;
    box-sizing: border-box;
    border-radius: 12px;
    background-color: #FFFFFF;
    border: 1px solid #ECEDEE;
    box-shadow: 0 2px 8px rgba(1, 39, 59, 0.06);
  }

  .section-title {
    margin-bottom: 20px;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: #01273B;
  }

  .section-description {
    margin-bottom: 16px;
    font-size: 14px;
    line-height: 22px;
    color: #01273B;
  }

  .personal-data-btn-container {
    width: 231px;
    height: 40px;
  }

  .personal-data-btn-container ::v-deep .button {
    min-height: 40px;
    max-height: 40px;
    border-radius: 10px;
    font-size: 14px;
    line-height: 24px;
  }

  .route-name {
    @include route-name;
    margin-bottom: 15px;
  }

  .back-block {
    width: fit-content;
    height: 40px;
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  .back-img {
    margin-right: 4px;
    height: 18px;
    width: 18px;
  }

  .back-btn-text {
    font-weight: 400;
    font-size: 16px;
    line-height: 135%;
    color: #878787;
  }

  @media screen and (max-width: 1155px) {
    .change-personal-data-wrapper {
      padding-top: 40px;
    }

    .change-personal-data-container {
      @include base-page-container;

      align-items: flex-start;
      padding-top: 0;
    }
  }

  @media screen and (max-width: 900px) {
    .personal-data-btn-container {
      width: 100%;
    }
  }
</style>
